export { FavoritesListFull } from "./favoritesListFull.ui";
export { useFavoritesListFullScript } from "./favoritesListFull.script";
export { FavoritesListFullWidget } from "./favoritesListFull.widget";
